import { createContext, useContext, useState, useCallback } from "react";

const LeadModalContext = createContext(null);

export function LeadModalProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [source, setSource] = useState("hero");

    const openModal = useCallback((src = "cta") => {
        setSource(src);
        setOpen(true);
    }, []);
    const closeModal = useCallback(() => setOpen(false), []);

    return (
        <LeadModalContext.Provider value={{ open, source, openModal, closeModal, setOpen }}>
            {children}
        </LeadModalContext.Provider>
    );
}

export function useLeadModal() {
    const ctx = useContext(LeadModalContext);
    if (!ctx) throw new Error("useLeadModal must be used within LeadModalProvider");
    return ctx;
}
